/*
 * Copyright 2025 Hypergiant Galactic Systems Inc. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import { useContext } from 'react';
import { Text, type TextProps } from 'react-aria-components';
import { TreeContext } from './context';
import { TreeStyles } from './styles';

const { description } = TreeStyles();

/**
 * ItemDescription - Description for a tree item
 *
 * Renders secondary descriptive text for a tree item
 */
export function TreeItemDescription({ children, className }: TextProps) {
  const { variant } = useContext(TreeContext);

  return variant !== 'crammed' ? (
    <Text
      data-slot='description'
      className={description({ className, variant })}
    >
      {children}
    </Text>
  ) : null;
}
